import { axiosInstance } from "@src/api/axiosConfig";
import { useQuery } from "react-query";
import { axiosPath } from "@src/api/axiosPath";
import { useMutation } from "react-query";
import { ExpertInfoResponse, ExpertApprovalStatusResponse, PutExpertInfo } from "./expert.type";

// 전문가 정보 조회
export const getExpertInfo = async () => {
    const response = await axiosInstance.get<ExpertInfoResponse>(`${axiosPath.expertInfo}`);
    return response?.data;
};

export const useGetExpertInfo = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["expertInfo"],
        queryFn: getExpertInfo,
    });
    return { data, isLoading, error, refetch };
};


// 전문가 정보 수정 (성공 여부만 반환)
export const updateExpertInfo = async (body: PutExpertInfo): Promise<boolean> => {
    const response = await axiosInstance.put(`${axiosPath.expertUpdate}`, body);
    return response?.data;
};

export const usePutExpertInfo = () => {
    return useMutation({
        mutationFn: (body: PutExpertInfo) => updateExpertInfo(body),
    });
};


// 매수신청대리인 승인 여부 조회
export const getExpertApprovalStatus = async () => {
    const response = await axiosInstance.get<ExpertApprovalStatusResponse>(`${axiosPath.expertApprovalStatus}`);
    return response?.data;
};


export const useGetExpertApprovalStatus = () => {
    const { data, isLoading, error } = useQuery({
        queryKey: ["expertApprovalStatus"],
        queryFn: getExpertApprovalStatus,
    });
    return { data, isLoading, error };
};
